import { Component } from '@angular/core';
import { TimeoutQueue } from '@common/services/timeout-queue';
import { SearchResults } from '@common/data-models/search-results/search-results';
import { AppService } from '@suite/app.service';
import { ClipboardTypes } from "@common/enums/clipboard-types";
import { DateTime } from '@common/data-models/complex-types/date-time';
import { MultiValue } from '@common/data-models/complex-types/multi-value';
import { LookupList } from '@common/data-models/complex-types/lookup-list';
import { Address } from '@common/data-models/complex-types/address';
import Handlebars from 'handlebars/dist/cjs/handlebars';

import { LanguageSettings } from '@common/services/language-settings';

@Component({
    selector: 'clipboard',
    templateUrl: './clipboard.html',
    styleUrls: ['./clipboard.scss']
})
export class Clipboard {
    public renderedHtml: string = "";
    private static initialized: boolean = false;

    constructor(
        public timeoutQueue: TimeoutQueue,
        public appService: AppService,
        public languageSettings: LanguageSettings
    ) {
        if (!Clipboard.initialized) {
            Handlebars.registerHelper("date", function (text) {
                if (text instanceof DateTime) return text.toDateTimeString();
            })

            Handlebars.registerHelper("checklist", function (text) {
                if (text instanceof MultiValue) return text.toString();
            })


            Handlebars.registerHelper("staffidlist", function (text) {
                if (text instanceof MultiValue) return text.toString();
            })


            Handlebars.registerHelper("lookuplist", function (text) {
                if (text instanceof LookupList) return text.toString();
            })

            Handlebars.registerHelper("address", function (text) {
                if (text instanceof Address) return text.formattedAddress;
            })

            Handlebars.registerHelper("glang", function (text) {
                return this.languageSettings.get(text);
            })

            Handlebars.registerHelper("assignment", function (item) {
                return item.fn(this.rawData)
            })

            Handlebars.registerHelper("topic", function (item) {
                return item.fn(this.rawData)
            })

            Clipboard.initialized = true;
        }
    }

    public async copy(data: any, type: ClipboardTypes, applicationName?: string) {
        // Clear selection
        if (window.getSelection) {
            if (window.getSelection().empty) {  // Chrome
                window.getSelection().empty();
            } else if (window.getSelection().removeAllRanges) {  // Firefox
                window.getSelection().removeAllRanges();
            }
        }
        await this.renderHtml(data, type, applicationName);
        this.appService.applicationRef.tick();
        this.timeoutQueue.setTimeout(async () => {
            if (window.getSelection) {
                const el = document.getElementById("clipboardContainer")
                await navigator?.clipboard?.writeText(el.innerText);
            }
        }, 100);
    }

    public static renderers: { [id: string]: (any, ClipboardTypes) => Promise<string> } = {};

    private async renderHtml(data: any, type: ClipboardTypes, applicationName?: string) {
        const res = await Clipboard.renderers[applicationName ? applicationName : this.appService.applicationName](data, type);
        this.renderedHtml = res;
    }

    public static copyViewToClipboardHandlers: { [id: string]: () => Promise<void> } = {};
    public async copyViewToClipBoard(applicationName?: string) {
        await Clipboard.copyViewToClipboardHandlers[applicationName ? applicationName : this.appService.applicationName]();
    }

}
